export default "__VITE_ASSET__BfFzYXLb__"